import React from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { LocalizationContext } from '../../hoc/Localization';
import { EditorWizardContext } from '../../hoc/EditorWizard';
import { UserContext } from '../../hoc/User';
import Button from '../Button';
import Login from '../Auth/Login';
import styles from './nextStepStyles.less';

const NextButton = props => {
  const { t } = React.useContext(LocalizationContext);
  const { user } = React.useContext(UserContext);
  const { nextStep, previousStep } = React.useContext(EditorWizardContext);
  const { disabled, notPassed, step, stepClassName } = props;

  const next = () => {
    if (notPassed) {
      notification.error({
        message: t('school.edit.schoolEmail.warning'),
      });
    } else {
      nextStep();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.footer}>
        <div>
          {step > 0 && (
            <div className={stepClassName || styles.step}>
              {`${t('course.create.wizard.step.text')} ${step}/7`}
            </div>
          )}
        </div>
        <div className={styles.next_previous}>
          <div className={styles.previous}>
            {!user ? (
              <Login>
                <a>
                  <Button version="large" type="secondary" onClick={() => previousStep()}>
                    <LeftOutlined />
                    {t('course.create.wizard.back')}
                  </Button>
                </a>
              </Login>
            ) : (
                <Button
                  version="large"
                  type="secondary"
                  name="wizard_back_button"
                  onClick={() => previousStep()}
                >
                  <LeftOutlined />
                  {t('course.create.wizard.back')}
                </Button>
              )}
          </div>
          <div>
            {!user ? (
              <Login>
                <a>
                  <Button version="large" type="primary" disabled={disabled} onClick={() => next()}>
                    {t('course.create.wizard.button.next')}
                  </Button>
                </a>
              </Login>
            ) : (
                <Button
                  version="large"
                  type="primary"
                  name="wizard_next_button"
                  disabled={disabled}
                  onClick={() => next()}
                >
                  {t('course.create.wizard.button.next')}
                </Button>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

NextButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  notPassed: PropTypes.bool,
  stepClassName: PropTypes.string,
  step: PropTypes.string,
};

NextButton.defaultProps = {
  notPassed: false,
  stepClassName: '',
  step: '',
};

export default NextButton;
